import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { Analytics } from "@/shared/utils/analytics/analytics";
import { BettingMode } from "../betting-mode";

export class AnalyticsProduct {
    fullPrice: number;
    pocketPrice: number;
    price: number;
    tax: number;
    position: number;
    verticalCode: string;
    gameCode: string;
    boards: number;
    draws: number;
    addonGame: string;
    bettingMode: string;
    drawDays: string;
    drawTimes: string;
    ticketKind: BettingMode | string;
    repetitionEndDate: string;

    constructor(
        price: number,
        boards: number,
        draws: number,
        drawDays: string,
        gameCode: Lottery,
        addonGame: "sance" | "extra6" | "eurosance" | "sancemilion" | "multiplier" | "" | Lottery,
        ticketKind: string,
        drawTimes: "aft" | "evn" | "aftevn" | "",
        repetitionEndDate: string,
        isQuickWager?: boolean
    ) {
        this.price = this.fullPrice = this.pocketPrice = price;
        this.tax = 0;
        this.position = 1;
        this.verticalCode = "loterie";
        this.gameCode = Analytics.getLotteryCode(gameCode);
        this.boards = boards;
        this.draws = draws;
        this.addonGame = addonGame?.toString() || null;
        this.ticketKind = ticketKind;
        this.drawDays = drawDays;
        this.drawTimes = drawTimes;
        this.bettingMode = isQuickWager ? "quickTips" : null;
        if (repetitionEndDate) this.repetitionEndDate = repetitionEndDate;
    }

    public static Eurojackpot(
        price: number,
        boards: number,
        duration: number,
        addonPlayed: boolean,
        drawDays: string,
        bettingMode: BettingMode,
        repetitionEndDate: string,
        isQuickWager?: boolean
    ): AnalyticsProduct {
        return new AnalyticsProduct(
            price,
            boards,
            duration,
            drawDays,
            Lottery.eurojackpot,
            addonPlayed ? "extra6" : "",
            bettingMode,
            null,
            repetitionEndDate,
            isQuickWager
        );
    }

    public static Euromiliony(
        price: number,
        boards: number,
        duration: number,
        addonPlayed: boolean,
        drawNames: string,
        bettingMode: BettingMode,
        repetitionEndDate: string,
        isQuickWager?: boolean
    ): AnalyticsProduct {
        return new AnalyticsProduct(
            price,
            boards,
            duration,
            drawNames,
            Lottery.euromiliony,
            addonPlayed ? "eurosance" : "",
            bettingMode,
            null,
            repetitionEndDate,
            isQuickWager
        );
    }

    public static Sportka(
        price: number,
        boards: number,
        duration: number,
        addonPlayed: boolean,
        drawDays: string,
        isExtra: boolean,
        bettingMode: BettingMode,
        repetitionEndDate: string,
        isQuickWager?: boolean
    ): AnalyticsProduct {
        return new AnalyticsProduct(
            price,
            boards,
            duration,
            drawDays,
            Lottery.sportka,
            addonPlayed ? "sance" : "",
            isExtra ? "sportkaMH" : bettingMode,
            null,
            repetitionEndDate,
            isQuickWager
        );
    }

    public static VsechnoNeboNic(price: number, boards: number, duration: number): AnalyticsProduct {
        return new AnalyticsProduct(
            price,
            boards,
            duration,
            "",
            Lottery.vsechnoNeboNic,
            "",
            duration == 1 ? "singleDraw" : "multiDraw",
            null,
            null, // VNN does not have bettingMode
            null
        );
    }

    public static MultiwagerGame(
        price: number,
        boards: number,
        draws: number,
        duration: number,
        gameCode: Lottery,
        addonGame: "sance" | "extra6" | "eurosance" | "sancemilion" | "multiplier" | "" | Lottery,
        bettingMode = "mutibets"
    ): AnalyticsProduct {
        return new AnalyticsProduct(
            price,
            boards,
            draws,
            AnalyticsProduct.getDrawDate(gameCode),
            gameCode,
            addonGame,
            duration == 1 ? "singleDraw" : "multiDraw",
            AnalyticsProduct.getDrawTimes(gameCode),
            bettingMode,
            null
        );
    }

    private static getDrawDate(lotteryName: string) {
        switch (lotteryName) {
            case "eurojackpot":
                return "fr";
            case "sportka":
                return "wesu";
            case "euromiliony":
                return "tusa";
            default:
                return "";
        }
    }

    private static getDrawTimes(lotteryName: string) {
        return lotteryName == "kasicka" || lotteryName == "stastnych10" ? "aftevn" : "";
    }
}
